//utils => dizini ver
const STORAGE_KEY = "ERROR_LOGS_V1";
const MAX_ENTRIES = 200;

function _readStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        console.error("Error reading error logs storage", e);
        return [];
    }
}

function _writeStorage(arr) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
        console.error("Error writing error logs storage", e);
    }
}

/**
 * entry = {
 *   id: string,
 *   timestamp: ISOString,
 *   message: string,
 *   stack: string|null,
 *   view: { name: string|null, path: string|null },
 *   component: { name: string|null, info: string|null },
 *   source: string, // "vue-error" | "window-error" | "promise-rejection" | ...
 *   extra: object|null
 * }
 */
export function logError(entry) {
    try {
        const errors = _readStorage();
        errors.unshift(entry); // newest first
        if (errors.length > MAX_ENTRIES) errors.length = MAX_ENTRIES;
        _writeStorage(errors);
    } catch (e) {
        console.error("Failed to log error", e);
    }
}

export function getErrors() {
    return _readStorage();
}

export function clearErrors() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        console.error("Failed to clear error logs", e);
    }
}

export function exportErrorsAsJson() {
    return JSON.stringify(_readStorage(), null, 2);
}